import { SearchResult } from './search-utils';

const STORAGE_KEY = 'recent-searches';
const MAX_ITEMS = 10;

export interface RecentSearch {
  id: string;
  type: 'contact' | 'deal' | 'note';
  title: string;
  subtitle: string;
  timestamp: number;
}

export function getRecentSearches(): RecentSearch[] {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return [];
    return JSON.parse(stored) as RecentSearch[];
  } catch {
    return [];
  }
}

export function addRecentSearch(result: SearchResult): void {
  try {
    let searches = getRecentSearches();

    // Remove if already exists
    searches = searches.filter((s) => !(s.id === result.id && s.type === result.type));

    // Create new entry
    const newEntry: RecentSearch = {
      id: result.id,
      type: result.type,
      title:
        result.type === 'contact'
          ? result.name
          : result.type === 'deal'
            ? result.title
            : result.body?.substring(0, 50) || 'Note',
      subtitle:
        result.type === 'contact'
          ? result.email || ''
          : result.type === 'deal'
            ? result.contactName || result.stageName || ''
            : result.dealTitle || '',
      timestamp: Date.now(),
    };

    // Add to front
    searches.unshift(newEntry);

    // Keep only latest MAX_ITEMS
    searches = searches.slice(0, MAX_ITEMS);

    localStorage.setItem(STORAGE_KEY, JSON.stringify(searches));
  } catch (e) {
    console.warn('Failed to save recent search:', e);
  }
}

export function clearRecentSearches(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    console.warn('Failed to clear recent searches:', e);
  }
}
